import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import type { KitShape } from 'fym-shared/src/music24/studioThemes';
import { TypedMemo } from '../../../../../common/types';
import { studioMessages } from '../../studioMessages';
import { DetailField } from '../DetailField';
import { PickTile } from './PickTile';
import { imageTileMessages } from './imageTileMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the image tiles; each part uses its own slice of it */
import styles from './ImageTiles.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ShapeTilesProps {
  value?: KitShape;
  onChange: (shape: KitShape) => void;
}

/** "Shape" of a feed post (design studio-details a2): 4:5 portrait and 1:1 square as tiles. */
const ShapeTilesComponent: React.FC<ShapeTilesProps> = ({ value = '4:5', onChange }) => {
  const intl = useIntl();
  const title = intl.formatMessage(studioMessages.shapeTitle);
  return (
    <DetailField title={title} hint={intl.formatMessage(imageTileMessages.shapeHint)}>
      <div className={clsx(styles.tiles, styles.two)} role="radiogroup" aria-label={title}>
        <PickTile
          small
          testId="shape-4:5"
          name={intl.formatMessage(imageTileMessages.shapePortrait)}
          isOn={value === '4:5'}
          preview={<span className={clsx(styles.shape, styles.shapePortrait)} />}
          benefit={intl.formatMessage(imageTileMessages.shapePortraitBenefit)}
          onPick={() => onChange('4:5')}
        />
        <PickTile
          small
          testId="shape-1:1"
          name={intl.formatMessage(imageTileMessages.shapeSquare)}
          isOn={value === '1:1'}
          preview={<span className={clsx(styles.shape, styles.shapeSquare)} />}
          benefit={intl.formatMessage(imageTileMessages.shapeSquareBenefit)}
          onPick={() => onChange('1:1')}
        />
      </div>
    </DetailField>
  );
};

export const ShapeTiles = TypedMemo(ShapeTilesComponent);
